import InputFile from '@anm/components/InputFile';
import { FC } from 'react';
import {
  ButtonCancel,
  ButtonWrapper,
  CancelledLabel,
  CancelTooltip,
  Label,
  ProgressAnimation,
  ProgressPanel,
  ProgressValue,
  ProgressWrapper,
  ReplaceVideoTooltip,
  TooltipText,
  Wrapper
} from './Wrapper';
import vtConfig from '../../../../config';
import isMobile from '@anm/helpers/is/isMobile';
import useReplaceVideoProgress from './hooks/useReplaceVideoProgress';
import useUpload from './hooks/useUpload';

const allowedExtensionsList = vtConfig()
  .supportedVideoExtensions.map(e => `.${e}`)
  .join();

const ButtonState: FC = () => {
  const handleUpload = useUpload();
  const [showProgress, currentUploadProgress, isCancelled] = useReplaceVideoProgress();

  switch (true) {
    case isCancelled:
      return (
        <CancelledLabel size="medium" iconSize="24x24" icon="images/icons/icon_replace_red.svg" variant="blue-link">
          Cancelled
        </CancelledLabel>
      );

    case showProgress:
      return (
        <ProgressWrapper>
          <ProgressPanel>
            <ProgressAnimation />
            <ProgressValue>{`${currentUploadProgress}%`}</ProgressValue>
          </ProgressPanel>

          <CancelTooltip
            withArrow
            variant="black"
            direction="to-top"
            renderContent={isMobile() ? undefined : () => <TooltipText>Cancel replacing video</TooltipText>}
          >
            <ButtonCancel
              size="medium"
              iconSize="24x24"
              // onClick={handleCancelUpload}
              icon="images/icons/cancel_icon.svg"
              variant="blue-link"
            />
          </CancelTooltip>
        </ProgressWrapper>
      );

    default:
      return (
        <ReplaceVideoTooltip
          withArrow
          variant="black"
          direction="to-top"
          renderContent={
            isMobile()
              ? undefined
              : () => (
                  <TooltipText>
                    Pick or upload a new version of a video, without changing the link to the video, embed codes, and
                    permissions
                  </TooltipText>
                )
          }
        >
          <Label>
            <InputFile handleUpload={handleUpload} accept={allowedExtensionsList} />
            <ButtonWrapper size="medium" iconSize="24x24" icon="images/icons/icon_replace.svg" variant="blue-link">
              Replace video
            </ButtonWrapper>
          </Label>
        </ReplaceVideoTooltip>
      );
  }
};

const ReplaceVideoButton: FC = () => {
  return (
    <Wrapper>
      <ButtonState />
    </Wrapper>
  );
};

export default ReplaceVideoButton;
